import { Component, OnInit } from '@angular/core';
import { ProfileDetails } from 'features/personal-info/personal-info.component';
import { ActivatedRoute } from '@angular/router';
import { PersonalInfoCommunicationService } from 'features/personal-info/personal-info.service';

@Component({
  selector: 'cm-profile-details',
  templateUrl: './profile-details.component.html',
  styleUrls: ['./profile-details.component.scss'],
})
export class ProfileDetailsComponent implements OnInit {
  profile: ProfileDetails;

  constructor(
    private route: ActivatedRoute,
    private personalInfoCommunicationService: PersonalInfoCommunicationService,
  ) {}

  ngOnInit() {
    this.profile = this.route.snapshot.data.profile;
  }

  updateProfile(newProfile: ProfileDetails) {
    this.personalInfoCommunicationService.emitUpdateProfile(newProfile);
  }
}
